<template>
    <div>
        <hts-form
            :rules="rules"
            @submit="handleSubmit">
            <div class="flex flex-col gap-2 overflow-hidden">
                <div>
                    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
                        <div>
                            <hts-card class="mb-4">
                                <template #title>
                                    <h3 class="title">
                                        <span class="label-text">
                                            {{ $t('labels.timeReposeDateByHorse') }} <span class="text-error-500">
                                                *
                                            </span>
                                        </span>
                                    </h3>
                                </template>
                                <div>
                                    <hts-form-input
                                        v-model="dataTimes.timeReposeDriver"
                                        :min="0"
                                        :max="24"
                                        type="number"
                                        :number-decimal="1"
                                        required
                                        name="timeReposeDateByHorse"
                                        prop="timeReposeDateByHorse" />
                                </div>
                            </hts-card>
                            <hts-card>
                                <template #title>
                                    <h3 class="title">
                                        <span class="label-text">
                                            {{ $t('labels.averagedNumberDateMonth') }} <span class="text-error-500">
                                                *
                                            </span>
                                        </span>
                                    </h3>
                                </template>
                                <div>
                                    <hts-form-input
                                        v-model="dataTimes.workingTime"
                                        :min="0"
                                        required
                                        type="number"
                                        name="averagedNumberDateMonth"
                                        prop="averagedNumberDateMonth" />
                                </div>
                            </hts-card>
                        </div>
                        <div class="min-w-[400px]">
                            <hts-card>
                                <template #title>
                                    <h3 class="title">
                                        <span class="label-text">
                                            {{ $t('labels.listHoliday') }}
                                        </span>
                                    </h3>
                                </template>
                                <div
                                    v-for="(item, index) in dataTimes.holidays"
                                    :key="index"
                                    class="flex">
                                    <div class="w-full flex items-center">
                                        <hts-form-date
                                            v-model="item.times"
                                            type="date"
                                            range
                                            class="w-full"
                                            required
                                            :color="props.color"
                                            :name="'timeReposeDriver' + index"
                                            :prop="'timeReposeDriver' + index"
                                            :placeholder="$t('labels.holiday')" />
                                        <hi-x-circle-icon
                                            class="h-6 w-6 mb-3 ml-2 text-error-600 cursor-pointer"
                                            @click="deleteHoliday(index)" />
                                    </div>
                                </div>
                                <div class="flex mt-2 text-main-600">
                                    <div
                                        class="flex cursor-pointer"
                                        @click="addHoliday">
                                        <hi-plus-circle-icon class="h-5 w-5" />
                                        <span>
                                            {{ $t('labels.add1') }}
                                        </span>
                                    </div>
                                </div>
                            </hts-card>
                        </div>
                    </div>
                </div>

                <div>
                    <hts-form-button
                        class="text-right"
                        icon-name="hi-clipboard-document-check-icon"
                        icon-position="right"
                        color="primary"
                        type="submit">
                        {{ $t('labels.save') }}
                    </hts-form-button>
                </div>
            </div>
        </hts-form>
    </div>
</template>

<script lang="ts" setup>
import { IGlobalSettingTimes } from './ignore/imports/form'

const { $disableReactive } = useNuxtApp()

const props = defineProps({
  globalSettingsInformation: {
    type: Object,
    default: () => {}
  }
})
const { globalSettingsInformation } = toRefs(props)
const dataTimes = ref<IGlobalSettingTimes>({
  timeReposeDriver: null,
  holidays: [
    {
      name: '',
      times: [],
      from: null,
      to: null
    }
  ]
})

const emits = defineEmits(['updateData'])
onMounted(() => {
  Object.assign(dataTimes.value, $disableReactive(globalSettingsInformation.value.times))
})

const addHoliday = () => {
  dataTimes.value.holidays.push({
    name: '',
    from: null,
    to: null,
    times: []
  })
}
const deleteHoliday = (index: number) => {
  dataTimes.value.holidays.splice(index, 1)
}
const store = $store()

const modifiedDateHoliday = () => {
  dataTimes.value.holidays.forEach((item, index: number) => {
    dataTimes.value.holidays[index].from = item.times[0]
    dataTimes.value.holidays[index].to = item.times[1]
  })
}

const handleSubmit = () => {
  const api = $urlPartner.settings.updateTimesSettings
  modifiedDateHoliday()
  $api(api, { body: { times: dataTimes.value } })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        store.globalSettings.setGlobalSettings(responseData.data)
        emits('updateData')
        process.client && $toast().success($t('notifications.updateSuccess'))
      }
    })
    .catch(() => {
      process.client && $toast().error($t('notifications.updateError'))
    })
}

const rules = {
  timeReposeDateByHorse: 'required',
  averagedNumberDateMonth: 'required'
}
</script>
